import { MedicineDetails } from '@dreryk/drerykweb-medicine-api';

import { createTranslatedText } from '@dreryk/react-common';
import { Notification, NotificationSize, NotificationType } from '@dreryk/react-components';

import { mapMarketStatusSymbolToAvailabilitySeverity, MedicineAvailabilitySeverity } from '~libs.shared.medicine';

const mapAvailabilitySeverityToNotificationType: Record<MedicineAvailabilitySeverity, NotificationType> = {
   positive: NotificationType.SUCCESS,
   informative: NotificationType.INFO,
   warning: NotificationType.WARNING,
   negative: NotificationType.ERROR,
};

type MedicineDetailsStatusProps = {
   readonly medicineDetails: MedicineDetails;
};

const MedicineDetailsMarketStatus = (props: MedicineDetailsStatusProps): JSX.Element => {
   const availabilitySeverity = mapMarketStatusSymbolToAvailabilitySeverity(props.medicineDetails.marketStatusSymbol);
   return (
      <Notification
         type={mapAvailabilitySeverityToNotificationType[availabilitySeverity]}
         label={createTranslatedText(props.medicineDetails.marketStatusShortName)}
         size={NotificationSize.SMALLER}
         testId={'marketStatus'}
      />
   );
};

export { MedicineDetailsMarketStatus };
